import $ from 'jquery';

if($(window).width() < 800) {
  require('./TamanhoTabsMobile');
} else {
  require('./TamanhoTabsDesktop');
}
